import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Modal, Button } from 'antd';

import EntityDetails from '../../../../components/forms/EntityDetailsForm';
import { configureInfoDetails, configureUserDetails } from './OrgtableConfig';
// Local Deps
import history from '../../../../config/history';

import NFButton from '../../../../components/primitives/NFButton';
// import { homeRoute } from '../../../../config/navigation/routes';
import msgs from '../../../../config/messages';
import { homeRoute } from '../../../../config/navigation/routes';
import { isFeatureEnabled } from '../../../../config/featureFlags';

// import Loading from '../../components/Loading';

export default class Summary extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    // continueWithoutCage: PropTypes.bool.isRequired,
    organization: PropTypes.any.isRequired,
    cage: PropTypes.string.isRequired,
    currentFlow: PropTypes.string.isRequired,
    // orgExists: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    orgAdmin: PropTypes.bool.isRequired,
    handleOk: PropTypes.func,
    continueWithoutRFQ: PropTypes.bool.isRequired,
    closeModalFailedRegistration: PropTypes.func.isRequired,
    finalSubmit: PropTypes.string,
  };

  static defaultProps = {
    handleOk: () => {
      window.scroll(0, 0);
      history.push(homeRoute);
    },
    finalSubmit: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {
      openBillsbyPopUp: false
    }
  }

  toggleBillsbyPopupModal = () => {
    this.setState({ openBillsbyPopUp: !this.state.openBillsbyPopUp });
  }

  render() {
    const {
      onSubmit,
      // orgType,
      onCancel,
      // continueWithoutCage,
      continueWithoutRFQ,
      currentFlow,
      cage,
      name,
      // orgExists,
      phone,
      email,
      organization,
      handleOk,
      closeModalFailedRegistration,
    } = this.props;

    const orgAdmin = currentFlow === 'industry' || this.props.orgAdmin;

    const infoItems = configureInfoDetails({
      cage,
      organization,
    });

    const UserItems = configureUserDetails({
      name,
      email,
      phone,
      // orgType,
      orgAdmin: orgAdmin ? 'Organization Admin' : 'User',
    });

    return (
      <div>
        <Row style={{ flexWrap: 'nowrap' }}>
          <Col style={{ marginTop: '16px' }}>
            {/* <!-- LOADING --> */}
            {/* <!-- CONTENT --> */}
            <div className="nf-registration__content">
              <Row className="nf-row--justify-end" />
              {/* <!-- USERS GRID --> */}
              {/* <div>
                <div>
                  <h3>USER {!continueWithoutCage && currentFlow === "new" ? ` - ${name} ${orgExists ? ' - User' : ' - Organization Admin'}` : ""}</h3>
                </div>
                {(continueWithoutCage || currentFlow !== "new") && <EntityDetails currentFlow={currentFlow} items={UserItems} organization={organization.name} />}
              </div> */}
              <div>
                <div>
                  <h3>USER </h3>
                </div>
                <EntityDetails currentFlow={currentFlow} items={UserItems} continueWithoutRFQ={continueWithoutRFQ} organization={organization.name} />
              </div>
              <div
                style={{
                  marginTop: '32px',
                  marginBottom: '32px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              />
              {(currentFlow === "new" || currentFlow === "industry") && (
                <div>
                  <div>
                    <h3>ORGANIZATION</h3>
                  </div>
                  <EntityDetails items={infoItems} />
                </div>
              )}

              <div className="nf-registration__layout">
                <div
                  style={{
                    marginTop: '32px',
                    marginBottom: '32px',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div className="nf-registration__buttons">
                    <NFButton
                      className="nf-button--gray-border"
                      style={{ marginRight: '16px' }}
                      onClick={() => {
                        onCancel();
                      }}
                    >
                      {msgs.Form.backButton}
                    </NFButton>
                    <NFButton
                      className="nf-button--form nf-button--orange"
                      type="submit"
                      onClick={() => {
                        onSubmit();
                      }}
                    >
                      {msgs.Form.submitButton}
                    </NFButton>
                    <Modal
                      visible={this.props.finalSubmit === "success"}
                      title="Welcome!"
                      onOk={() => { handleOk(email, orgAdmin) }}
                      centered
                      footer={[
                        <Button key="submit" type="primary" onClick={() => handleOk(email, orgAdmin)}>
                          OK
                        </Button>,
                      ]}
                    >
                      {orgAdmin && (
                        <p>
                          Your request will be reviewed by our site
                          administrator. Please check your email for notice of
                          account approval and your user credentials.
                        </p>
                      )}
                      {!orgAdmin && (
                        <p>
                          Your request will be reviewed by our site administrator.
                          Please check your email for notice of account approval
                          and your user credentials.
                        </p>
                      )}
                      {!orgAdmin && currentFlow === 'new' && isFeatureEnabled('ENABLE_BILLSBY') && (
                        <p>
                          Once you are able to login, you will be directed to sign up for a subscription.
                        </p>
                      )}
                    </Modal>
                    <Modal
                      visible={this.state.openBillsbyPopUp}
                      title="Account Review Policy"
                      centered
                      footer={[
                        <Button type="primary" onClick={() => {
                          this.toggleBillsbyPopupModal();
                          history.push(homeRoute)
                        }}>Continue</Button>
                      ]}
                    >
                      <p>
                        {"The ICON Super Admin will review your account and approve. Please check your approval email."}
                      </p>
                    </Modal>

                    <Modal
                      visible={this.props.finalSubmit === "failure"}
                      title="Registration Failed"
                      onOk={closeModalFailedRegistration}
                      centered
                      footer={[
                        <Button type="primary" onClick={closeModalFailedRegistration}>
                          Try Again
                        </Button>,
                      ]}
                    >
                      <p>
                        Registration failed. Please try again. If the problem persists contact support.
                      </p>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/Summary/Summary.jsx